import { DateTime } from "luxon";
import type { Board } from "./api";
import { addDays } from "./format";

/**
 * Late in the day there is little left to plan, so the board opens tomorrow instead. The
 * ramp list is the opposite case: it is about the next few hours, and tonight's last
 * arrivals are exactly what the people reading it are waiting for. Only the board moves.
 */
export function dayToOpen(b: Pick<Board, "date" | "now" | "turns" | "airport">, view: string): string | null {
  if (view !== "board") return null;
  const remaining = b.turns.filter((t) => t.end > b.now).length;
  const hour = DateTime.fromMillis(b.now, { zone: b.airport.timezone }).hour;
  return remaining < 6 || hour >= 21 ? addDays(b.date, 1) : null;
}
